import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton';

const SubmitModal = ({
  open,
  title = 'Are you sure ?',
  content = '',
  onSubmit = () => {},
  onClose = () => {},
  deleteContent
}) => {
  const actions = [
    <FlatButton
      label="Cancel"
      primary
      onTouchTap={onClose}
    />,
    <FlatButton
      label="Submit"
      primary
      keyboardFocused
      onTouchTap={onSubmit}
    />,
  ];
  return (
    <Dialog
      title={title}
      modal
      open={open}
      actions={actions}
    >
      {content}
      {deleteContent ?
        `You are about to delete ${deleteContent}, please click 'Submit' to continue.`
        :
        ''
      }
    </Dialog>
  )
}

SubmitModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.string,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  deleteContent: PropTypes.string,
}
SubmitModal.defaultProps = {}

export default SubmitModal



// WEBPACK FOOTER //
// ./src/components/modals/SubmitModal.js